import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ui/icons';
import { ResponsiveImage } from '@web/molecules/index.js';
import { useReporter } from '../../reporter';
import { dropOffPathClicked } from '../events';
import {
  DropoffCallout,
  DropoffHeadline,
  DropoffLinkOverlay,
  DropoffLinkText,
  Content,
  DropoffBody,
  LinkContainer,
} from './styles.js';

export const DropoffPath = ({
  image,
  headline,
  text,
  linkText,
  linkTarget,
  flowType,
}) => {
  const reporter = useReporter();

  return (
    <DropoffCallout>
      {linkTarget && (
        <DropoffLinkOverlay
          href={linkTarget}
          aria-label={`go to ${linkTarget}`}
          onClick={() => reporter.tag(dropOffPathClicked(flowType, linkTarget))}
        />
      )}
      {image && (
        <ResponsiveImage
          src={image.src}
          alt={image.alt}
          height={100}
          width={95}
        ></ResponsiveImage>
      )}
      <Content>
        {headline && <DropoffHeadline>{headline}</DropoffHeadline>}
        {text && <DropoffBody>{text}</DropoffBody>}
        {linkText && (
          <LinkContainer>
            <DropoffLinkText>{linkText}</DropoffLinkText>
            <Icon
              iconName="arrow-forward"
              alt="arrow-forward"
              color={'text.link'}
              size="15"
              id={`arrow`}
            />
          </LinkContainer>
        )}
      </Content>
    </DropoffCallout>
  );
};
DropoffPath.displayName = 'DropoffPath';

DropoffPath.propTypes = {
  headline: PropTypes.string,
  image: PropTypes.object,
  text: PropTypes.string,
  linkText: PropTypes.string,
  linkTarget: PropTypes.string,
};
